import { Component, DestroyRef, OnInit } from '@angular/core';
import { UtilService } from '../../../services/util.service';
import { API, VisitorTrackerFullDTO } from '../../../services/api/api';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from '../../../services/error.service';
import { NavigationService } from '@ngx-seatback/utils';
import { TrackerCreationComponent } from '../../../components/tracking/tracker-creation/tracker-creation.component';
import { ModalService } from '../../../services/gui/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from '../../../services/permission.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-tracker-details',
  templateUrl: './tracker-details.component.html',
  styleUrls: ['./tracker-details.component.scss'],
  standalone: false,
})
export class TrackerDetailsComponent implements OnInit {
  tracker: VisitorTrackerFullDTO;
  trackerId: number;
  loading: boolean;
  status: TrackerDetailsOnlineStatus[];

  constructor(
    public util: UtilService,
    private api: API,
    private activatedRoute: ActivatedRoute,
    public errorHandler: ErrorService,
    private navService: NavigationService,
    private modal: ModalService,
    private translate: TranslateService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.tracker = undefined;
    this.trackerId = undefined;
    this.loading = true;
    this.status = [];
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.trackerId = +params.trackerID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    this.api
      .dm_visitor_VisitorTracker_retrieveById(this.trackerId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (tracker: VisitorTrackerFullDTO) => {
          this.tracker = tracker;
          this.status = [];

          this.status.push({ type: 'disabled', value: this.tracker.disabled });
          this.status.push({ type: 'productive', value: this.tracker.productive });
          this.status.push({ type: 'online', value: !this.tracker.offline });
          this.status.push({ type: 'external', value: this.tracker.external });
        },
        error: error => {
          if (error.status && (+error.status === 403 || +error.status === 404)) {
            this.navService.navigateToPoint(this.util.RoutingID.tracker);
          } else {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }

  editTracker() {
    this.modal
      .showNavigationModal({
        entryComponent: {
          value: TrackerCreationComponent,
          data: {
            tracker: this.tracker,
            editMode: true,
          },
        },
        title: this.translate.instant('nav.network.tracker') + ' ' + this.tracker.id + ': ' + this.tracker.name,
        icon: 'settings',
        modalOptions: { size: 'lg' },
      })
      .then(() => {
        this.refresh();
      })
      .catch(() => {
        this.refresh();
      });
  }
}

export interface TrackerDetailsOnlineStatus {
  type: string;
  value: boolean;
}
